import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import { Trans, useTranslation } from '@whoop/i18n/lang/client';
import { UnstyledButton } from 'ui/components/ButtonV2/Button';
// TODO: Commented out datadog dependencies that were used on join-flow but want to revisit using them in the future
// import {
//   DATADOG_FLOW_TYPE,
//   DATADOG_TAGS,
//   sendLogToDataDog,
// } from '@/lib/utils/datadogLogger';
// import {
//   processDatadogTags,
//   processErrorForDatadog,
// } from '@/lib/utils/datadogHelpers';

export interface ErrorProps {
  error: Error & { digest?: string };
  context: string;
}

function ErrorComponent({ error, context }: ErrorProps): JSX.Element {
  const { t } = useTranslation('errorComponent');

  useEffect(() => {
    Sentry.captureException(error, {
      tags: { 'error-component': context },
    });
    // const errorContext = processErrorForDatadog(error);

    // // Have message contain first 35 characters of error message
    // sendLogToDataDog({
    //   logMessage: `Error Component - ${
    //     errorContext?.errorMessage
    //       ? (errorContext.errorMessage as string).substring(0, 35)
    //       : 'Unknown Error'
    //   }`,
    //   condensedTags: '',
    //   context: errorContext,
    // });
  }, [error]);

  const reloadPage = () => {
    window.location.reload();
  };

  return (
    <div className='min-h-[calc(100vh-180px)]'>
      <div className='mx-auto max-w-prose text-center'>
        <h2 className='pt-10 text-2xl'>{t('somethingWentWrong')}</h2>
        <p>
          <Trans
            components={[
              <UnstyledButton
                className='text-red-500'
                key='try-again-button'
                onClick={reloadPage}
                type='submit'
              />,
            ]}
            i18nKey='errorComponent:tryAgainText'
          />
        </p>
        <p className='pt-4'>
          <Trans
            components={[
              // eslint-disable-next-line jsx-a11y/anchor-has-content
              <a
                className='text-red-500'
                href='mailto:support@whoop.com'
                key='support-email'
              />,
              // eslint-disable-next-line jsx-a11y/anchor-has-content
              <a
                className='text-red-500'
                href='https://www.amazon.com/stores/page/38494EE6-760A-40C4-9012-77FE85A94079'
                key='amazon-link'
                rel='noopener'
                target='_blank'
              />,
            ]}
            i18nKey='errorComponent:shopSupportText'
          />
        </p>
      </div>
    </div>
  );
}

export default ErrorComponent;
